/**
 * `react-native-teleport` host name for the persistent answer `KeyboardToolbar`.
 * Render a matching `PortalHost` outside nested `KeyboardStickyView` trees (see root layout).
 */
export const PERSISTENT_KEYBOARD_TOOLBAR_PORTAL_HOST_NAME = "han-persistent-keyboard-toolbar";
